import React, { useEffect } from 'react';
import { Box, Flex, Image, Text } from '@chakra-ui/react'
import About from './About';
import { useSearchParams } from 'react-router-dom';
import { setOrgId } from '../Redux/userDetails/userSlice';
import { useDispatch } from 'react-redux';

const LandingPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    useEffect(() => {
        let orgId = searchParams.get("orgId")
        dispatch(setOrgId(orgId))
    }, [])

    return (
        <>
            <Box h={[250, 350]} w="100%" bgColor="#F0ECF9" >
                <Flex px={[3, 100]} justifyContent={{ base: "space-between", sm: "space-between", lg: "end" }} align="center">
                    <Text lineHeight={1} mt={[-50, 0]} fw="semibold" fontSize={[30, 60]} fontFamily={"Sans serif"} w={[270, 550]}>Transform the way you work with your team.</Text>
                    <Image src="team.svg" alt="team" w={[200, 500]} h="300px" mt={[-15, 35]} />
                </Flex>
            </Box>
            <About />
            <Flex h="60px" w="100%" bgColor="#F0ECF9" align="center" justify="center" mt={5}>
                <Text fw="bold">Created By team Teamiply</Text>
            </Flex>

        </>
    )
}

export default LandingPage
